const ADMIN_PASSWORD = "C2t3ir@ml@vT";

export const verifyAdminPassword = (password: string): boolean => {
  return password === ADMIN_PASSWORD;
};

// Store auth state in sessionStorage so it persists across page refreshes but clears when browser is closed
export const setAdminAuthenticated = (authenticated: boolean) => {
  if (authenticated) {
    sessionStorage.setItem('adminAuthenticated', 'true');
  } else {
    sessionStorage.removeItem('adminAuthenticated');
  }
};

export const isAdminAuthenticated = (): boolean => {
  return sessionStorage.getItem('adminAuthenticated') === 'true';
};
